module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/UOqwTJ/media/FC-9781035824830.jpg?1718046516583",
      "alt": "This image is the cover for the book Diary of a Manwhore"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Diary of a Manwhore\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Embark on a raw and raunchy journey through the world of online dating, as narrated by a man on a quest to find himself. His sometimes-painful honesty and insightful reflections will captivate you as his journey of self-discovery navigates the highs and lows of the dating game. Not all revelations about himself are pleasing, yet he is resolute in pursuing the wildest of dates. This relentless pursuit, however, pushes boundaries too far, leading to a profound personal revelation.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ed Davies\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Ed lives in North Bondi in Sydney’s beautiful Eastern Suburbs. He likes the cafe scene and firmly believes that brunch is the best meal of the day. He enjoys training outside and surfing at his local break. He has been known to take the odd photo and enjoy a glass of shiraz or two.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0